import * as apis from './api';
const withUrl = (url, method) => (ins) => (params, ...rest) => ins[method](url, params, ...rest);
export const configRequest = (ins) => ({
    modelList: withUrl(apis.getModelList, 'get')(ins),
    save: withUrl(apis.postSave, 'post')(ins),
    disCountList: withUrl(apis.getDisCountList, 'post')(ins),
    picList: withUrl(apis.postPicList, 'post')(ins),
    featureList: withUrl(apis.getFeatureList, 'get')(ins),
    priceGet: withUrl(apis.postPriceGet, 'post')(ins),
    showAll: withUrl(apis.postShowAll, 'post')(ins),
    switch3D: withUrl(apis.getSwitch3D, 'get')(ins),
    optionDetail: withUrl(apis.getOptionDetail, 'get')(ins),
    getTopTip: withUrl(apis.getTopTip, 'get')(ins),
    generationGroupDetailInfo: withUrl(apis.getGenerationGroupDetailInfo, 'get')(ins),
    generationGroupDetailInfoByModel: withUrl(apis.getGenerationGroupDetailInfoByModel, 'get')(ins),
    subsidyPolicy: withUrl(apis.getSubsidyPolicy, 'get')(ins),
    setValue: withUrl(apis.setValue, 'post')(ins),
    setUniqueValue: withUrl(apis.setUniqueValue, 'post')(ins),
    getValue: withUrl(apis.getValue, 'get')(ins),
    getContractPop: withUrl(apis.getContractPop, 'post')(ins),
    getPreviewContract: withUrl(apis.getPreviewContract, 'post')(ins),
    reSignCheckConfigurator: withUrl(apis.reSignCheckConfigurator, 'post')(ins),
    startOrderPreview: withUrl(apis.startOrderPreview, 'post')(ins),
    signContract: withUrl(apis.signContract, 'post')(ins),
    updateOrder: withUrl(apis.updateOrder, 'post')(ins),
    getGuideList: withUrl(apis.getGuideList, 'get')(ins),
    getIsLockOrder: withUrl(apis.getIsLockOrder, 'post')(ins),
    sendMessage: withUrl(apis.sendMessage, 'post')(ins),
    lockOrder: withUrl(apis.lockOrder, 'post')(ins),
    shareInfo: withUrl(apis.shareInfo, 'post')(ins),
    getQrCode: withUrl(apis.getQrCode, 'post')(ins),
    getQrCodeNew: withUrl(apis.getQrCodeNew, 'post')(ins),
    getAreaList: withUrl(apis.getAreaList, 'get')(ins),
    addressRgeo: withUrl(apis.addressRgeo, 'get')(ins),
    getAreaByLocation: withUrl(apis.getAreaByLocation, 'get')(ins),
    addressGrade: withUrl(apis.addressGrade, 'get')(ins),
    addressSubAddress: withUrl(apis.addressSubAddress, 'get')(ins),
    getCDCList: withUrl(apis.getCDCList, 'post')(ins),
    getCardList: withUrl(apis.getCardList, 'post')(ins),
    newcutdown: withUrl(apis.newcutdown, 'post')(ins),
    getPayInfo: withUrl(apis.getPayInfo, 'post')(ins),
    getPurchaseInfo: withUrl(apis.getPurchaseInfo, 'post')(ins),
    getGenerationInfoByCode: withUrl(apis.getGenerationInfoByCode, 'get')(ins),
    getChangeOptionTips: withUrl(apis.getChangeOptionTips, 'post')(ins),
    getWishBasicInfo: withUrl(apis.getWishBasicInfo, 'get')(ins),
    getFellowMes: withUrl(apis.getFellowMes, 'post')(ins),
    getWishOrder: withUrl(apis.getWishOrder, 'post')(ins),
    getLoveOrderPrice: withUrl(apis.getLoveOrderPrice, 'get')(ins),
    getPreOrderCheck: withUrl(apis.getPreOrderCheck, 'get')(ins),
    getVersionDetail: withUrl(apis.getVersionDetail, 'get')(ins),
    ruleCheck: withUrl(apis.ruleCheck, 'post')(ins),
    padSaveWish: withUrl(apis.postSaveWishByPad, 'post')(ins),
    quotation: withUrl(apis.postQuotation, 'post')(ins),
    saveQuotation: withUrl(apis.saveQuotation, 'post')(ins),
    saveWishByQuotationNo: withUrl(apis.saveWishByQuotationNo, 'post')(ins),
    getQuotationDetail: withUrl(apis.getQuotationDetail, 'get')(ins),
    getQuotationList: withUrl(apis.getQuotationList, 'get')(ins),
    getQuotationLog: withUrl(apis.getQuotationLog, 'get')(ins),
    convertConfig: withUrl(apis.convertConfig, 'get')(ins),
    getLoanDetail: withUrl(apis.getLoanDetail, 'get')(ins),
    queryFinance: withUrl(apis.queryFinance, 'get')(ins),
    getShowAllEditable: withUrl(apis.getShowAllEditable, 'post')(ins),
    getAreaCodeList: withUrl(apis.getAreaCodeList, 'get')(ins),
    decryptSecurityData: withUrl(apis.decryptSecurityData, 'post')(ins),
    getDeliveryCenterList: withUrl(apis.getDeliveryCenterList, 'get')(ins),
    getDeliveryCenterListV2: withUrl(apis.getDeliveryCenterListV2, 'get')(ins),
    existCarList: withUrl(apis.existCarList, 'post')(ins),
    getCertificate: withUrl(apis.getCertificate, 'get')(ins),
    checkExistCar: withUrl(apis.checkExistCar, 'get')(ins),
    existCarViewUser: withUrl(apis.existCarViewUser, 'get')(ins),
    createQuotationOrder: withUrl(apis.createQuotationOrder, 'post')(ins),
    createExistCarOrder: withUrl(apis.createExistCarOrder, 'post')(ins),
    combinationList: withUrl(apis.combinationList, 'post')(ins),
    getOptionalPackageDetail: withUrl(apis.optionalPackageDetail, 'get')(ins),
    generationSoldOutPopup: withUrl(apis.generationSoldOutPopup, 'post')(ins),
    updateConfBlind: withUrl(apis.updateConfOptionBlind, 'post')(ins),
    cancelOrder: withUrl(apis.cancelOrder, 'post')(ins),
    setVehicleOptions: withUrl(apis.setVehicleOptions, 'post')(ins),
    getOldNewPriceCompare: withUrl(apis.getOldNewPriceCompare, 'post')(ins),
});
export const createConfigRequest = (ins) => () => configRequest(ins);
export * from './tools';
export * from './mock/feature-list';
export * from './mock/wish-basic-info';
export * from './mock/discount-list';
